import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAppSelector } from 'src/store/store'
import 'src/components/Relays/Details/DetailsPage.css'
import Details from 'src/components/Relays/Details/Details'
import { fetchRelay, fetchRelaysData } from 'src/api/api'
import { RelayDetailModel } from 'src/constants/DataModels'

const DetailsPage: React.FC = () => {
  const { relayId } = useParams()
  const [relay, setRelay] = useState<RelayDetailModel>()
  const [bridgingRelay, setBridgingRelay] = useState<RelayDetailModel>()

  const selector = useAppSelector
  const network = selector((state) => state.NetworkReducer.network)

  useEffect(() => {
    try {
      fetchRelay(relayId!).then((response) => {
        setRelay(response.data)
      })
    } catch (e: any) {
      console.error(e)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relayId, network])

  // For bridging relay
  const isBridgingRelay =
    relay && relay.transfer_payload?.transfer_payload_type === 'token_bridging'

  // If it is a bridging relay, find the next relay
  useEffect(() => {
    if (isBridgingRelay) {
      fetchRelaysData({ source_tx_hash: relay.destination_tx_hash }).then((response) => {
        const relays = response.data.data
        if (relays.length > 0) {
          fetchRelay(relays[0].id).then((res) => {
            setBridgingRelay(res.data)
          })
        }
      })
    }
  }, [isBridgingRelay, relayId, relay?.destination_tx_hash])


  if (!relay) {
    return <div>Loading relay..</div>
  }

  return (
    <div className="container main-wrapper">
      <div className="details-wrapper">
        {isBridgingRelay && <h3 className="relay-title">INBOUND RELAY</h3>}
        <Details txDetail={relay} />

        {isBridgingRelay && <h3 className="relay-title">OUTBOUND RELAY</h3>}
        {isBridgingRelay && bridgingRelay && <Details txDetail={bridgingRelay} />}
      </div>
    </div>
  )
}

export default DetailsPage
